/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesSystemLists.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for System List Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:58 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const SystemListGroups = Loadable({
    loader: () => import('../containers/SystemListGroups/SystemListGroupListContainer'),
    loading: Loading,
});

export const SystemListGroupEdit = Loadable({
    loader: () => import('../containers/SystemListGroups/SystemListGroupEditContainer'),
    loading: Loading,
});

export const SystemLists = Loadable({
    loader: () => import('../containers/SystemLists/SystemListListContainer'),
    loading: Loading,
});

export const SystemListEdit = Loadable({
    loader: () => import('../containers/SystemLists/SystemListEditContainer'),
    loading: Loading,
});

export const SystemListItems = Loadable({
    loader: () => import('../containers/SystemListItems/SystemListItemListContainer'),
    loading: Loading,
});

export const SystemListItemEdit = Loadable({
    loader: () => import('../containers/SystemListItems/SystemListItemEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesSystemLists.js